import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation,} from '@angular/core';
import {AppDatastore} from '../../core/services/app-store/app.datastore';
import {ActivatedRoute, Router} from "@angular/router";
import {NxMessageToastService} from "@aposin/ng-aquila/message";
import {FormBuilder, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {NxDialogService, NxModalRef} from "@aposin/ng-aquila/modal";
import {TranslateService} from "@ngx-translate/core";
import {MailService} from "../../mailservice/mail.service";
import {TrackingService} from "../../trackingservice/tracking.service";
import countries from 'i18n-iso-countries';
import moment from 'moment';

import de from 'i18n-iso-countries/langs/de.json';
import fr from 'i18n-iso-countries/langs/fr.json';
import it from 'i18n-iso-countries/langs/it.json';
import {NxMultiStepperComponent} from "@aposin/ng-aquila/progress-stepper";
import {StepperSelectionEvent} from "@angular/cdk/stepper";


countries.registerLocale(de);
countries.registerLocale(fr);
countries.registerLocale(it);

// @ts-ignore

/**
 * Validates phone numbers. International numbers are accepted if they contain a country code.
 *
 * @param type? (optional) Type of number, can be `mobile` or `landline`
 */

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class HomeComponent implements OnInit {
  // private storageKey = 'user-background';
  // private defaultColor = '#ff00ff';
  //  userBackgroundColor:string = '';

  public ship_age = -1;
  public ship_age_date: string = '';
  showDebug = false;
  @ViewChild('stepper')
  private myStepper!: NxMultiStepperComponent;
  phoneNumber: any;
  private jsonResponse: any;

  product = '';
  origin = '';
  selectedLanguage = 'de';

  componentDialogRef!: NxModalRef<HomeComponent>;

  readonly stepThreeForm = this.fb.group({
    zip: '',
    email: '',
    phone: '+41',
    availability: '',
    firstname: ['', Validators.required],
    lastname: ['', Validators.required],
    isCustomer: [false]
  });
  translatedCountries: any;

  // phone:FormControl;
  /**
   * Init Home Page
   *
   * @param appDataStore - App storage Service
   */
  constructor(private readonly fb: FormBuilder, public dialogService: NxDialogService, private trackingService: TrackingService, private mailService: MailService, private activatedRoute: ActivatedRoute, public appDataStore: AppDatastore, private router: Router, private messageToastService: NxMessageToastService, private httpClient: HttpClient, public translateService: TranslateService
  ) {

  }

  ngOnInit() {
    this.getJSONData();
    // this.loadBackgroundPreferences();
    this.trackingService.trackStep('start');
    this.activatedRoute.queryParams.subscribe(params => {

      if (params['debug']) {
        this.showDebug = params['debug'];
      }
      if (params['lang']) {
        this.translatedCountries = countries.getNames(params['lang'], {select: 'official'})
      } else {
        this.translatedCountries = countries.getNames('de', {select: 'official'})
      }

    });
  }

  getJSONData() {

    this.httpClient.get('https://al-angular-cdn.s3-eu-central-1.amazonaws.com/wfz2023/assets/json/agency.json').subscribe((data: any) => {
      // this.httpClient.get('/assets/json/agency.json').subscribe((data: any) => {
      this.jsonResponse = data;
    });
  }

  /*This method is used to update the ship_age according to the selected date. It calculates the difference between the current date and selected date in years and updates the ship_age accordingly.*/
  public onDateChange(event: any): void {
    let currentMoment = moment();
    let userDate = moment(event.value);
    this.ship_age_date = userDate.format('DD.MM.YYYY');
    this.ship_age = currentMoment.diff(userDate, 'years');
  }

  public onsubmit(_event: Event): void {

    const formData = new FormData();

    let emailSurfix = '.mail@allianz-suisse.ch';
    let emailPrefix = '';
    let email = '';

    for (var i = 0; i < this.jsonResponse.length; i++) {

      if (this.jsonResponse[i].plz === this.stepThreeForm.value.zip) {
        emailPrefix = this.jsonResponse[i].id.replace(/AS/g, "ga");
      }
    }

    email = emailPrefix + emailSurfix;

    let templateAstContent = '<tr>' +
      '        <td style="background-color: #fff;padding: 0px 0px 32px; text-align: center">' +
      '          <img style="display: block; height: auto; max-width: 50%; margin: 0 25%" src="https://al-cdn.s3-eu-central-1.amazonaws.com/wfz2024/email/az-lead-email-quality-4.png" width="300"  border="0" alt="">' +
      '        </td>' +
      '      </tr>' +
      '' +
      '      <tr>' +
      '        <td class="dark-wrapper" style="background-color: #fff; font-family: Arial, sans-serif; padding: 0px 0px 8px; padding-left: 10.5%; padding-right: 10.5%;" >' +
      '          <h2 style="color: #414141; font-size: 24px; font-weight: 400; line-height: 32px; margin: 0px;">' +
      '           Lead' +
      '          </h2>' +
      '        </td>' +
      '      </tr>' +
      '      <tr>' +
      '        <td class="dark-wrapper" style="background-color: #fff;font-size: 16px; line-height:24px; font-weight: 400; font-family: Arial, sans-serif; padding: 0px 0px 32px; padding-left: 10.5%; padding-right: 10.5%;">' +
      '          <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">' +
      '            <tbody>' +
      '            <tr >' +
      '              <td>Tool</td>' +
      '              <td>' + this.trackingService.trackingObject.application.applicationName + '</td>' +
      '            </tr>' +
      '            <tr>' +
      '              <td>Quelle</td>' +
      '              <td>' + this.trackingService.ls_src + '</td>' +
      '            </tr>' +
      '            <tr>' +
      '              <td>Kampagnenname</td>' +
      '              <td>' + this.trackingService.ls_campaign + '</td>' +
      '            </tr>' +
      '            </tbody>' +
      '          </table>' +
      '        </td>' +
      '      </tr>' +
      '      <tr>' +
      '        <td class="dark-wrapper" style="background-color: #fff; font-family: Arial, sans-serif; padding: 0px 0px 8px; padding-left: 10.5%; padding-right: 10.5%;" >' +
      '          <h2 style="color: #414141; font-size: 24px; font-weight: 400; line-height: 32px; margin: 0px;">' +
      '            Persönliche Daten' +
      '          </h2>' +
      '        </td>' +
      '      </tr>' +
      '      <tr>' +
      '        <td class="dark-wrapper" style="background-color: #fff;font-size: 16px; line-height:24px; font-weight: 400; font-family: Arial, sans-serif; padding: 0 0 32px; padding-left: 10.5%; padding-right: 10.5%;">' +
      '          <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">' +
      '            <tbody>' +
      '<tr>' +
      '              <td>Vorname</td>' +
      '              <td>' + this.stepThreeForm.value.firstname + '</td>' +
      '            </tr>' +
      '<tr>' +
      '              <td>Nachname</td>' +
      '              <td>' + this.stepThreeForm.value.lastname + '</td>' +
      '            </tr>' +
      '<tr>' +
      '              <td>Postleitzahl</td>' +
      '              <td>' + this.stepThreeForm.value.zip + '</td>' +
      '            </tr>' +
      '<tr>' +
      '              <td>E-Mail</td>' +
      '              <td>' + this.stepThreeForm.value.email + '</td>' +
      '            </tr>' +
      '<tr>' +
      '              <td>Telefon</td>' +
      '              <td>' + this.stepThreeForm.value.phone + '</td>' +
      '            </tr>' + '<tr>' +
      '              <td>Erreichbarkeit</td>' +
      '              <td>' + this.stepThreeForm.value.availability + '</td>' +
      '            </tr>' +
      '<tr>' +
      '              <td>Besantdskunde?</td>' +
      '              <td>' + this.stepThreeForm.value.isCustomer + '</td>' +
      '            </tr>' +
      '<tr>' +
      '              <td>   </td>' +
      '              <td>   </td>' +
      '            </tr>' +
      '<tr>' +
      '              <td>   </td>' +
      '              <td>   </td>' +
      '            </tr>'


    templateAstContent += '            </tbody>' +
      '          </table>' +
      '        </td>' +
      '      </tr>';


    if (this.stepThreeForm.value.zip !== '9999') {
      formData.append('email', email);
    } else {
      formData.append('email', this.stepThreeForm.value.email);
    }
    // let tempURL: string = 'https://www.allianz.ch/de/ldp/lead-bewertung-kb.html?leads=leadScore&lAr=3&lGa=AS71xxx&lApp=allianz-wfz&lCp=testLeadsWithGaWerber';
    let tempURL: string = 'https://www.allianz.ch/de/ldp/lead-bewertung-kb.html?leads=leadScore&lApp=allianz-l4y&lAr=4';
    if (this.trackingService.ls_name != '') tempURL = tempURL + '&lGa=' + this.trackingService.ls_name;
    if (this.trackingService.ls_campaign != '') tempURL = tempURL + '&lCp=' + this.trackingService.ls_campaign;
    if (this.trackingService.ls_kunde != '') tempURL = tempURL + '&lKn=' + this.trackingService.ls_kunde;
    // if (this.trackingService.ls_name != '') tempURL = tempURL + '&lGa=' + this.trackingService.ls_name;

    if (this.trackingService.ls_werber != '') tempURL = tempURL + '&lKb=' + this.trackingService.ls_werber;

    // formData.append('email', this.stepThreeForm.value.email);
    formData.append('content', templateAstContent);
    formData.append('subject', 'Neuer Lead | Kontaktformular | Bitte Kunde/in kontaktieren');
    formData.append('p1', tempURL + '&lKr=1');
    formData.append('p2', tempURL + '&lKr=2');
    formData.append('p3', tempURL + '&lKr=3');
    // formData.append('message', message);


    // const url = "https://wfz-2023.lespals.com/sendmail_2024.php";
    const url = "https://allianz-mailer.lespals.com/sendmail_test.php";

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.onload = function () {
      // console.log(this.responseText);
    };
    xhr.send(formData);
    this.myStepper.next();

  }

  changeZip() {

    const inputValue = this.stepThreeForm.value.zip;

    // Remove any non-digit characters from the input
    const digitsOnly = inputValue.replace(/\D/g, '');

    // Limit the input to 4 digits
    const limitedInput = digitsOnly.slice(0, 4);
    this.stepThreeForm.patchValue({zip: limitedInput});

    // Update the input value with the limited input
    // this.stepThreeForm.value.zip.value = limitedInput;
    console.log('####', this.stepThreeForm.value.zip);
    // if (this.jsonResponse != null) {
    for (var i = 0; i < this.jsonResponse.length; i++) {
      if (this.jsonResponse[i].plz === this.stepThreeForm.value.zip && this.trackingService.ls_name === '') {
        this.trackingService.ls_name = this.jsonResponse[i].id;
        console.log('####', this.trackingService.ls_name);
        this.trackingService.trackAgent();
      }
    }
    if (this.trackingService.ls_name === '') {
      this.trackingService.ls_name = 'ASTEST';
      console.log('####', this.trackingService.ls_name);

      this.trackingService.trackAgent();

    }
    // }

    // this.trackingService.trackZip(this.shippingAddressForm.value.zip);
  }

  updateStepper($event: StepperSelectionEvent) {
    console.log($event.selectedIndex);
    switch ($event.selectedIndex) {

      case 0: {
        this.trackingService.trackStep('start');
        // this.trackingService.trackAgent();

        break;
      }
      case 1: {
        this.trackingService.trackStep('success');
        // @ts-ignore
        _satellite.track("DCR: Consultation Complete");
        break;
      }
      default: {
        //statements;
        break;
      }
    }
  }


  changeClientNr() {
    // this.trackingService.ls_kunde = this.stepThreeForm.value.clientnr;
  }

  onOriginChange() {
    this.trackingService.ls_origin = this.toCamelCase(this.stepThreeForm.value.contactSelection);
  }

  toCamelCase(str: string) {
    return str.replace(/[-_](.)/g, (_, c) => c.toUpperCase()).replace(/\s/g, '');
    ;
  }
}
